var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"clipPath":"url(#clip-2D7516CD-F4C8-4D3E-A5B4-C4D794499200)"},React.createElement("path",{"fill":"currentColor","d":"M12.322.38c6.8 0 12.313 5.512 12.313 12.312S19.12 25.004 12.321 25.004C5.522 25.004.01 19.491.01 12.691.01 5.893 5.523.38 12.323.38zm6.935 12.809s.012-2.263-.286-3.349a1.736 1.736 0 0 0-1.222-1.222c-1.085-.297-5.427-.297-5.427-.297s-4.342 0-5.427.285c-.583.16-1.063.64-1.223 1.235-.285 1.086-.285 3.337-.285 3.337s0 2.263.285 3.338c.16.594.629 1.063 1.223 1.222 1.097.298 5.427.298 5.427.298s4.342 0 5.427-.286a1.737 1.737 0 0 0 1.222-1.223c.286-1.086.286-3.338.286-3.338zm-8.314-2.091l3.603 2.08-3.603 2.08z"}))));
}

YoutubeIcon.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
